import { defineMessages } from 'react-intl';

export const directCostsMessageDefinitions = defineMessages({
  costBreakDownTitle: {
    id: 'estimationDetail.directCosts.costBreakDownTitle',
    defaultMessage: 'Direct Cost Breakdown',
  },
  detailSum: {
    id: 'estimationDetail.directCosts.detail.sum',
    defaultMessage: 'Sum',
  },
  estimationItemName: {
    id: 'estimationDetail.directCosts.detail.estimationItemName',
    defaultMessage: 'Cost Name',
  },
  description: {
    id: 'estimationDetail.directCosts.detail.description',
    defaultMessage: 'Description',
  },
  title: {
    id: 'estimationDetail.directCosts.detail.title',
    defaultMessage: 'Edit Cost',
  },
  assumptionsButton: {
    id: 'estimationDetail.directCosts.detail.assumptionsButton',
    defaultMessage: 'Assumptions',
  },
  commentsButton: {
    id: 'estimationDetail.directCosts.detail.commentsButton',
    defaultMessage: 'Comments',
  },
  overrideOriginalEstimateButton: {
    id: 'estimationDetail.directCosts.detail.overrideOriginalEstimateButton',
    defaultMessage: 'Update Original Estimate',
  },
  subItemsTitle: {
    id: 'estimationDetail.directCosts.detail.subItemsTitle',
    defaultMessage: 'Sub-costs',
  },
  modalSavedMessage: {
    id: 'estimationDetail.directCosts.detail.saved',
    defaultMessage: 'Costs of sub-estimation items of "{mainEstimationItemName}" have been saved.',
  },
});
